import styled from "styled-components";

/** Breakpoint intermediário (1100px) - evita layout quebrado em resoluções como 1037x811 */
const BREAKPOINT_MEDIUM = "1100px";
/** Breakpoint mobile */
const BREAKPOINT_MOBILE = "768px";

export const Page = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.background};
  overflow-x: hidden;

  .planos-detail-save-btn .btn-label-mobile { display: none; }
  .planos-detail-save-btn .btn-label-full { display: inline; }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    .planos-detail-save-btn .btn-label-mobile { display: inline; }
    .planos-detail-save-btn .btn-label-full { display: none; }
  }
`;

export const HeaderSticky = styled.div`
  position: sticky;
  top: 0;
  z-index: 50;
  background: ${({ theme }) => theme.colors.background};
`;

export const HeaderInner = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 7px 24px;

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    padding: 7px 16px 7px 56px;
    gap: 12px;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0;

  .voltar-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
    background: transparent;
    border: none;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.interfaceGray400};

    svg {
      flex-shrink: 0;
      min-width: 20px;
      min-height: 20px;
    }

    @media (max-width: 800px) {
      display: none;
    }
  }

  .divider {
    width: 1px;
    height: 16px;
    margin: 0 20px;
    border-left: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};

    @media (max-width: 800px) {
      display: none;
    }
  }

  h1 {
    font-size: 32px;
    font-weight: 400;
    margin: 0;
    color: ${({ theme }) => theme.colors.interfaceText400 || theme.colors.interfaceTextPrimary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    max-width: min(100%, 60vw);

    @media (max-width: ${BREAKPOINT_MOBILE}) {
      font-size: 1.5rem;
      max-width: calc(100vw - 120px);
    }
  }
`;

export const TabNavSticky = styled.div<{ $sidebarCollapsed?: boolean }>`
  position: sticky;
  top: 73px;
  z-index: 40;
  background: ${({ theme }) => theme.colors.background};
  padding: 0 12px 32px;
  width: 100%;
  max-width: ${({ $sidebarCollapsed }) => ($sidebarCollapsed ? "min(2400px, calc(100vw - 144px))" : "min(2400px, calc(100vw - 320px))")};
  margin: 0 auto;
  box-sizing: border-box;

  @media (max-width: 768px) {
    top: 55px;
    padding: 0 16px 28px;
    max-width: 100%;
  }
`;

export const TabNavInner = styled.div`
  padding: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
`;

export const TabNav = styled.nav`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: stretch;
  background: ${(props: any) => props.theme.colors.interfacePure0};
  justify-content: center;
  width: 100%;
  border-radius: 6px;
  box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.1);
  padding: 0;
`;

export const TabButton = styled.button<{ $active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  gap: 8px;
  padding: 18px 20px;
  font-size: 14px;
  color: ${({ theme, $active }) => ($active ? theme.colors.primaryRed400 : theme.colors.interfaceText400)};
  border-bottom: 2px solid ${({ theme, $active }) => ($active ? theme.colors.primaryRed400 : "transparent")};
  background: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  user-select: none;
  white-space: nowrap;

  &:hover {
    opacity: 0.8;
  }
`;

export const Content = styled.div<{ $sidebarCollapsed?: boolean }>`
  padding: 24px 12px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;

  @media (min-width: 769px) {
    max-width: ${({ $sidebarCollapsed }) => ($sidebarCollapsed ? "min(2400px, calc(100vw - 144px))" : "min(2400px, calc(100vw - 320px))")};
  }
`;

export const ContentCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const LoadingWrap = styled.div`
  padding: 24px;
`;

export const ErrorWrap = styled.div`
  padding: 24px;
  text-align: center;
`;

export const ErrorMessage = styled.p`
  margin-bottom: 16px;
`;

export const RetryButton = styled.button`
  padding: 8px 16px;
`;

/* Card: Configurações gerais - mesma largura que abas */
export const Card = styled.section`
  padding: 24px;
  background: ${(props: any) => props.theme.colors.white};
  border: none;
  border-radius: 6px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    padding: 14px 16px 16px;
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    padding: 16px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 12px;
    gap: 8px;

    > *:last-child {
      display: flex;
      width: 100%;
      justify-content: center;
    }
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    margin-bottom: 20px;
    gap: 16px;
  }
`;

export const CardHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1 1 200px;
  max-width: 100%;
  flex-wrap: nowrap;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    flex: 1 1 50px;
    gap: 8px;
  }
`;

export const CardTitleWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;
  flex: 1;
  overflow: hidden;
`;

export const CardTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.interfaceTextPrimary};
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  .card-title-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    cursor: help;
    display: inline-block;
    max-width: 100%;
  }

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    font-size: 15px;

    .card-title-text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

export const StatusBadge = styled.span<{ $ativo: boolean }>`
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
  background: ${({ theme, $ativo }) =>
    $ativo ? theme.colors.interfaceSuccess100 : theme.colors.interfacePure100};
  color: ${({ theme, $ativo }) =>
    $ativo ? theme.colors.interfaceSuccess : theme.colors.interfaceGray400};
  border: 1px solid
    ${({ theme, $ativo }) =>
      $ativo ? theme.colors.interfaceSuccess200 : theme.colors.interfacePure200};
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: nowrap;
  white-space: nowrap;

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    flex-flow: row nowrap;
    gap: 8px;

    > button,
    > a {
      flex: 1 1 0;
      min-width: 0;
    }
  }
`;

export const ButtonSecondary = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.interfaceTextPrimary};
  white-space: nowrap;
`;

export const ButtonPrimary = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.primaryRed400};
  color: ${(props: any) => props.theme.colors.pureWhite};
  border: none;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
`;

export const ConfigGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    /* Ordem: linha1 Créditos+ValorPlano | linha2 ValorCrédito+ValorOnboard | linha3 Validade (full) */
    .field-creditos { grid-column: 1; grid-row: 1; }
    .field-valor-plano { grid-column: 2; grid-row: 1; }
    .field-valor-credito { grid-column: 1; grid-row: 2; }
    .field-valor-onboard { grid-column: 2; grid-row: 2; }
    .field-validade { grid-column: 1 / -1; grid-row: 3; }
  }

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    gap: 20px;
  }
`;

export const FieldCell = styled.div<{ $hasError?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;

  ${({ theme, $hasError }) =>
    $hasError &&
    `
    input,
    .default-input input {
      border-color: ${theme.colors.primaryRed400} !important;
      outline-color: ${theme.colors.primaryRed400};
    }
  `}
`;

export const FieldError = styled.span`
  color: ${({ theme }) => theme.colors.primaryRed400};
  font-size: 12px;
  font-weight: 500;
  margin-top: 4px;
  display: block;
  min-height: 18px;
  line-height: 1.3;
`;

export const ConfigErrorsSummary = styled.p`
  margin: 0 0 16px;
  padding: 12px 16px;
  background: ${({ theme }) => theme.colors.primaryRed100 || "#FEE2E2"};
  color: ${({ theme }) => theme.colors.primaryRed400};
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.primaryRed200 || "#FECACA"};
`;

export const InputMoneyWrap = styled.div`
  .default-input {
    min-height: 0;
    margin-bottom: 0;
  }
  .default-input input {
    margin-top: 0;
    width: 100%;
    min-width: 0;
    height: 40px;
  }
`;

/** Wrapper compacto para InputMoney na tabela de precificação (mesmo tamanho que tinha o InputValor). */
export const InputMoneyCell = styled.div`
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  .default-input {
    min-height: 0;
    margin: 0;
  }
  .default-input input {
    margin-top: 0;
    width: 100%;
    height: 32px;
    padding: 6px 8px;
    font-size: 14px;
    text-align: right;
  }
`;

export const FieldLabel = styled.label`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.interfaceGray400};
  text-transform: uppercase;
  font-weight: 500;
`;

export const FieldLabelDiv = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.interfaceGray400};
  text-transform: uppercase;
  font-weight: 500;
`;

export const InputDefault = styled.input`
  width: 100%;
  height: 40px;
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  border-radius: 6px;
  font-size: 14px;
`;

export const ValueRow = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ValueText = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.interfaceTextPrimary};
`;

export const ToggleRow = styled.div`
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    margin-top: 28px;
    padding-top: 28px;
    gap: 16px;
  }
`;

export const ToggleTrack = styled.button<{ $on: boolean }>`
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  background: ${({ theme, $on }) =>
    $on ? theme.colors.primaryRed400 : theme.colors.interfaceBorder100};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`;

export const ToggleThumb = styled.span<{ $on: boolean }>`
  position: absolute;
  top: 2px;
  left: ${({ $on }) => ($on ? 22 : 2)}px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${(props: any) => props.theme.colors.white};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: left 0.2s ease;
`;

export const ToggleLabel = styled.span`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.interfaceGray400};
  text-transform: uppercase;
  font-weight: 600;
`;

export const ViewValueRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

/* Card: Precificação de serviços */
export const PricingCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 10px;
    gap: 8px;

    /* Título em uma linha, botão Editar preços ocupa toda a linha abaixo */
    > *:first-child {
      width: 100%;
    }

    > *:last-child {
      display: flex;
      width: 100%;
      justify-content: center;
    }
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    margin-bottom: 20px;
    gap: 16px;
  }
`;

export const PricingCardHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1 1 auto;
`;

export const PricingIconWrap = styled.span`
  display: inline-flex;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
`;

export const PricingTitleWrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const PricingTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.interfaceTextPrimary};
  white-space: nowrap;
  min-width: 0;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    white-space: normal;
    word-break: break-word;
    flex: 1;
    min-width: 222px;
  }
`;

export const HelpIconWrap = styled.span`
  display: inline-flex;
  cursor: help;
  flex-shrink: 0;
  align-items: center;
  width: fit-content;
  min-width: 24px;

  /* Garante que o Tooltip interno não expanda e sobreponha o título */
  > div {
    display: inline-flex !important;
    width: auto !important;
    min-width: 0 !important;
    overflow: visible !important;
  }
`;

export const TableWrap = styled.div`
  overflow-x: auto;
  border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  border-radius: 6px;
  overflow: hidden;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    overflow: visible;
    border: none;
    border-radius: 0;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    display: none;
  }
`;

export const Thead = styled.thead``;

export const Th = styled.th`
  text-align: left;
  padding: 16px 12px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.interfaceGray400};
  font-weight: 600;
  background: ${(props: any) => props.theme.colors.cf8fafc};
  border-bottom: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};

  &.center {
    text-align: center;
  }
  &.right {
    text-align: right;
  }
`;

export const Tbody = styled.tbody``;

export const Tr = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  background: ${(props: any) => props.theme.colors.white};
`;

export const Td = styled.td`
  padding: 16px 12px;
  font-size: 14px;
  font-weight: 500;

  &.center {
    text-align: center;
  }
  &.right {
    text-align: right;
  }
`;

export const ModalidadeBadge = styled.span`
  background: ${({ theme }) => theme.colors.interfacePure100};
  color: ${({ theme }) => theme.colors.interfaceTextPrimary};
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
`;

/** Wrapper para célula da tabela de precificação com input + erro abaixo (centralizado) */
export const PricingCellWithError = styled.div<{ $hasError?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  &.mobile-align-start {
    align-items: flex-start;
  }

  ${({ theme, $hasError }) =>
    $hasError &&
    `
    input, .default-input input {
      border-color: ${theme.colors?.primaryRed400 || "#dc2626"} !important;
      outline-color: ${theme.colors?.primaryRed400 || "#dc2626"};
    }
  `}
`;

export const InputSmall = styled.input`
  width: 56px;
  padding: 6px 8px;
  border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  border-radius: 6px;
  font-size: 14px;
  text-align: center;
`;

export const InputValor = styled.input`
  width: 80px;
  padding: 6px 8px;
  border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  border-radius: 6px;
  font-size: 14px;
  text-align: right;
`;

export const TotalValue = styled.span`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.interfaceSuccess};
`;

export const ConsultaBadge = styled.span`
  background: ${(props: any) => props.theme.colors.cfef3c7};
  color: ${(props: any) => props.theme.colors.c92400e};
  border: 1px solid rgb(252, 211, 77);
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
`;

export const ToggleSwitch = styled.button<{ $on: boolean }>`
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  background: ${({ theme, $on }) =>
    $on ? theme.colors.primaryRed400 : theme.colors.interfaceBorder100};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`;

export const ToggleSwitchThumb = styled.span<{ $on: boolean }>`
  position: absolute;
  top: 2px;
  left: ${({ $on }) => ($on ? 22 : 2)}px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${(props: any) => props.theme.colors.white};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: left 0.2s ease;
`;

export const HistoricoPlaceholder = styled.div`
  padding: 48px;
  text-align: center;
  color: ${({ theme }) => theme.colors.interfaceGray400};
`;

/* Mobile card layout para listagem de serviços */
export const MobileCardList = styled.div`
  display: none;
  flex-direction: column;
  gap: 12px;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    display: flex;
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    gap: 18px;
  }
`;

export const MobileServiceCard = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    padding: 18px;
  }

  .mobile-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 8px;
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    .mobile-card-header {
      margin-bottom: 12px;
    }
    .mobile-card-tag-profissional {
      margin-bottom: 12px;
    }
    .mobile-card-creditos {
      margin-bottom: 12px;
    }
  }
  .mobile-card-header > *:first-child {
    min-width: 0;
    flex: 1;
    overflow: hidden;
  }
  .mobile-card-servico {
    font-weight: 700;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.interfaceTextPrimary};
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .mobile-card-tag-profissional {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 8px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.interfaceGray400};
  }
  .mobile-card-creditos {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.interfaceGray400};
    margin-bottom: 8px;
  }
  .mobile-card-valor-cr {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.interfaceGray400};
    white-space: nowrap;
  }
`;

export const MobileCardTotal = styled.span`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.interfaceSuccess};
  flex-shrink: 0;
`;

export const MobileCardEditRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    margin-top: 16px;
    padding-top: 16px;
    gap: 16px;
  }

  .mobile-edit-field {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
  }
  .mobile-edit-field .label {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.interfaceGray400};
    white-space: nowrap;
    flex-shrink: 0;
  }
`;

/* Empty state quando não há serviços na precificação */
export const EmptyPricingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  background: ${({ theme }) => theme.colors.interfacePure100 || '#F9FAFB'};
  border-radius: 8px;
  margin: 0 1px;
`;

export const EmptyPricingIcon = styled.div`
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.interfaceGray400 || '#9CA3AF'};
`;

export const EmptyPricingTitle = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.interfaceText || '#374151'};
  margin: 0 0 8px 0;
`;

export const EmptyPricingMessage = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.interfaceGray500 || '#6B7280'};
  margin: 0 0 20px 0;
  max-width: 360px;
  line-height: 1.5;
`;

export const EmptyPricingLink = styled.button`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primaryRed400 || '#DC2626'};
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 6px;
  transition: background 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.interfaceGray150 || 'rgba(0,0,0,0.04)'};
  }
`;
